module.exports = __webpack_public_path__ + "media/bootstrap-icons/house-fill-615c6353.svg";